var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              { staticClass: "single container-max page-content mt-5 pt-5" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "h1",
                      {
                        staticClass: "my-border-bottom",
                        attrs: { "data-testing": "item-name" },
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-muted text-small mt-3" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketItemId")
                          ) +
                          " " +
                          _vm._s(_vm.currentVariation.item.id) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "mt-3",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.currentVariation.texts.shortDescription
                        ),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm.extendedItemData.garantie.length > 0
                    ? _c("div", { staticClass: "col-lg-6" }, [
                        _c(
                          "div",
                          { staticClass: "power-warranty d-none d-lg-block" },
                          _vm._l(
                            _vm.extendedItemData.garantie,
                            function (icon) {
                              return _c("img", {
                                staticClass: "img-fluid mr-2",
                                attrs: { src: icon },
                              })
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-5" }, [
                  _c(
                    "div",
                    { staticClass: "col-lg-6 order-2 order-lg-1" },
                    [
                      _c("div", {
                        staticClass: "d-none d-lg-block",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentVariation.texts.description
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _vm.cross.length > 0
                        ? [
                            _c(
                              "h2",
                              { staticClass: "my-border-bottom mb-4 mt-5" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$translate(
                                        "BeckerTech::Template.singleCross"
                                      )
                                    ) +
                                    "\n                  "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(_vm.cross, function (items) {
                                return _c(
                                  "div",
                                  { staticClass: "col-3 text-center" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "/" +
                                            items.data.texts.urlPath +
                                            "_" +
                                            items.data.item.id +
                                            "_" +
                                            items.data.variation.id,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid",
                                          attrs: {
                                            src: _vm.getImage(
                                              items.data.images
                                            ),
                                          },
                                        }),
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(items.data.texts.name2) +
                                            "\n                      "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-6 order-1 order-lg-2" },
                    [_vm._t("image-carousel")],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h2", { staticClass: "my-border-bottom mb-4 mt-5" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$translate(
                              "BeckerTech::Template.singleCertificats"
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-wrap flex-lg-nowrap align-items-end",
                      },
                      [
                        _vm.extendedItemData.zertifikate.length > 0
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "certificates ml-lg-5 order-sm-2",
                                },
                                [
                                  _c(
                                    "ul",
                                    {
                                      staticClass: "list-inline list-unstyled",
                                    },
                                    _vm._l(
                                      _vm.extendedItemData.zertifikate,
                                      function (zert) {
                                        return _c(
                                          "li",
                                          { staticClass: "list-inline-item" },
                                          [
                                            _c("img", {
                                              staticClass: "img-fluid",
                                              attrs: { src: zert },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "order-sm-1" }, [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.technicalData
                              ),
                            },
                          }),
                        ]),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h2", { staticClass: "my-border-bottom mb-4 mt-5" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.singleItemTechnicalData"
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _vm.extendedItemData.merkmale.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 col-lg-7 order-2 order-lg-1",
                            },
                            [
                              _c("h3", [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.$translate(
                                        "BeckerTech::Template.singleMerkmale"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.extendedItemData.merkmale,
                                  function (merkmal) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 col-lg-4 text-center",
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid",
                                          attrs: { src: merkmal.image },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "text-small" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(merkmal.desc) +
                                                "\n                      "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.extendedItemData.performance.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "col-12 col-lg-5 order-1 order-lg-2",
                            },
                            [
                              _c("h3", [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.$translate(
                                        "BeckerTech::Template.singlePerformance"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src:
                                    "https://cdn02.plentymarkets.com/iccu94qfd9gw/propertyItems/" +
                                    _vm.extendedItemData.performance[0],
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.extendedItemData.dataSheet !== ""
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "h2",
                          { staticClass: "my-border-bottom mb-4 mt-5" },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$translate(
                                    "BeckerTech::Template.singleData"
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.extendedItemData.dataSheet),
                          },
                        }),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.extendedItemData.downloads.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "h2",
                          { staticClass: "my-border-bottom mb-4 mt-5" },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.$translate(
                                    "BeckerTech::Template.singleData"
                                  )
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "ul",
                            {
                              staticClass:
                                "list-unstyled list-inline downloads",
                            },
                            _vm._l(
                              _vm.extendedItemData.downloads,
                              function (download) {
                                return _c("li", {
                                  staticClass:
                                    "list-inline-item mr-4 text-center",
                                  domProps: { innerHTML: _vm._s(download) },
                                })
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "bg-green px-5 py-3 mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "widget widget-code widget-none mb-0" },
                    [
                      _c("div", { staticClass: "widget-inner bg-appearance" }, [
                        _c("div", { staticClass: "container-max py-5" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center flex-wrap",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "claim text-white col-12 col-lg-7 text-center text-lg-left",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$translate(
                                          "BeckerTech::Template.singlehead"
                                        )
                                      ) +
                                      "\n                      "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-lg-5 text-center mt-5 mt-lg-0",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-outline-white",
                                      attrs: {
                                        href: _vm.$translate(
                                          "BeckerTech::Template.singleoffersPage"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(
                                            _vm.$translate(
                                              "BeckerTech::Template.singleaction"
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }